'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _querystring = require('querystring');

var _jsCookie = require('js-cookie');

var dontTrack = window.location && window.location.search && (0, _querystring.parse)(window.location.search.replace(/^\?/, '')).dontTrack;

//keep dont track in a cookie to allow reloads.
if (document) {
  if (dontTrack === 'true' || dontTrack === 'false') {
    (0, _jsCookie.set)('dontTrack', dontTrack, { domain: 'rategravity.com' });
  } else {
    dontTrack = (0, _jsCookie.get)('dontTrack');
  }
}

exports.default = dontTrack === 'true';


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/dont-track.js